import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private http = inject(HttpClient);

  async getTokenHistory(address: string, timeframe: string, symbol: string): Promise<any> {
    const res: any = await firstValueFrom(
      this.http.get(`${environment.apiUrl}/user/token/${address}/history?timeframe=${timeframe}&symbol=${symbol}`)
    );
    return res;
  }
}
